/* HB — cache court des résultats validés, isolé par URL complète. */
(() => {
  'use strict';
  if (window.HBCollectionRequests) return;
  const entries = new Map();
  const ttl = 45000;
  const enabled = () => !window.Shopify?.designMode;
  const keyFor = input => {
    const url = new URL(input, location.href);
    if (url.origin !== location.origin || !url.searchParams.has('section_id')) return null;
    return [url.href, document.documentElement.lang, window.Shopify?.country,
      window.Shopify?.currency?.active, window.Shopify?.theme?.id].join('|');
  };
  window.HBCollectionRequests = {
    fetch(input, options) {
      const key = keyFor(input);
      const entry = key && enabled() && entries.get(key);
      if (options?.signal?.aborted) return Promise.reject(new DOMException('Aborted', 'AbortError'));
      if (entry && Date.now() - entry.at < ttl) {
        entries.delete(key); entries.set(key, entry);
        return Promise.resolve(new Response(entry.html, {headers:{'Content-Type':'text/html'}}));
      }
      if (key) entries.delete(key);
      return fetch(input, options);
    },
    remember(input, html) {
      const key = keyFor(input);
      if (!key || !enabled() || typeof html !== 'string' || html.length > 300000) return;
      entries.delete(key);
      entries.set(key, {html, at:Date.now()});
      while (entries.size > 6) entries.delete(entries.keys().next().value);
    },
    clear() { entries.clear(); }
  };
  document.addEventListener('cart:updated', () => entries.clear());
  const listenToCart = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => entries.clear());
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listenToCart, {once:true});
  else listenToCart();
  document.addEventListener('shopify:section:load', () => entries.clear());
  window.addEventListener('pageshow', event => { if (event.persisted) entries.clear(); });
})();
